package com.macrofocus.eflux.ui.table

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.TableType
import com.macrofocus.eflux.network.DerivedBranchColumn
import com.macrofocus.eflux.network.DerivedBusColumn
import com.macrofocus.eflux.network.crossborder.crossborder
import com.macrofocus.eflux.network.line.Line
import com.macrofocus.eflux.network.physical.Branch
import com.macrofocus.eflux.network.physical.Bus
import com.macrofocus.eflux.network.substation.Substation
import emotion.react.css
import mui.material.*
import mui.material.Size
import mui.system.Box
import org.mkui.react.useProperty
import org.mkui.react.useSelection
import org.molap.dataframe.rowmajor.AccessorRowMajorDataFrame
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import react.*
import react.dom.events.ChangeEvent
import react.dom.onChange
import web.cssom.*
import web.html.HTMLDivElement
import web.html.HTMLInputElement
import web.html.InputType
import web.html.search

external interface TableViewProps : Props {
    var dataLoader: DataLoader

    //    var viewLoader: ViewLoader
    var show: Boolean
    var transparent: BackgroundColor?
    var tableType: MutableProperty<TableType>?
    var crossBorder: MutableProperty<Boolean>?
}

public val TableView = FC<TableViewProps> { props ->
    if (!props.show) {
        return@FC
    }

    val (getPhysicalNetwork, _) = useProperty(props.dataLoader.physicalNetwork)
    val (getLogicalNetwork, _) = useProperty(props.dataLoader.logicalNetwork)
    val (getSubstationNetwork, _) = useProperty(props.dataLoader.substationNetwork)
    val (getSelection, _) = useSelection(props.dataLoader.logicalBranchSelection)

    val (tableType, setTableType) = useProperty(if (props.tableType != null) props.tableType!! else props.dataLoader.configuration.tableType)
    val (crossBorder, setCrossBorder) = useProperty(if (props.crossBorder != null) props.crossBorder!! else props.dataLoader.configuration.crossBorder)
    val (zoneFilter, setZoneFilter) = useProperty(props.dataLoader.configuration.zoneFilter)
    val (filter, setFilter) = useProperty(props.dataLoader.configuration.filter)

    val selection = getSelection.mapNotNull { getLogicalNetwork?.logicalLinks?.get(it)?.branch }

    if (getLogicalNetwork == null || getSubstationNetwork == null) {
        return@FC
    }

    val nodes: List<Substation> = useMemo(crossBorder, zoneFilter, filter, getSubstationNetwork) {
        getSubstationNetwork.nodes
            .filter {
                val combinedBuses = it.buses!!
                zoneFilter.isEmpty() ||
                        if (zoneFilter.contains("-")) {
                            val split = zoneFilter.split("-")
                            val from = split[0]
                            val to = split[1]
                            combinedBuses.primaries.any {
                                it.zone?.name?.startsWith(
                                    from,
                                    true
                                ) ?: false || it.zone?.name?.startsWith(to, true) ?: false
                            }
                        } else {
                            combinedBuses.primaries.any { it.zone?.name?.startsWith(zoneFilter, true) ?: false }
                        }
            }
            .filter {
                val combinedBuses = it.buses!!
                filter.isEmpty() ||
                        combinedBuses.primaries.any { it.id.startsWith(filter, true) } ||
                        combinedBuses.fullName.contains(filter, true)
            }
    }

    val links: List<Line> = useMemo(crossBorder, zoneFilter, filter, getSubstationNetwork) {
        (if (crossBorder) {
            getSubstationNetwork.links.filter {
                val combinedBranches = it.branches!!
                combinedBranches.branch.crossBorder
            }
        } else getSubstationNetwork.links)
            .filter {
                val combinedBranches = it.branches!!
                zoneFilter.isEmpty() ||
                        if (zoneFilter.contains("-")) {
                            val split = zoneFilter.split("-")
                            val from = split[0]
                            val to = split[1]
                            (combinedBranches.branch.zone_k?.name?.startsWith(
                                from,
                                true
                            ) ?: false && combinedBranches.branch.zone_m?.name?.startsWith(to, true) ?: false) ||
                                    (combinedBranches.branch.zone_k?.name?.startsWith(
                                        to,
                                        true
                                    ) ?: false && combinedBranches.branch.zone_m?.name?.startsWith(from, true) ?: false)
                        } else {
                            combinedBranches.branch.zone_k?.name?.startsWith(
                                zoneFilter,
                                true
                            ) ?: false || combinedBranches.branch.zone_m?.name?.startsWith(zoneFilter, true) ?: false
                        }
            }
            .filter {
                val combinedBranches = it.branches!!
                filter.isEmpty() ||
                        it.logicalBranchId.name.contains(filter, true) ||
                        combinedBranches.branch.longName.contains(filter, true) ||
                        combinedBranches.branch.id.contains(filter, true)
            }
    }

    if (true) {
        val filter =
            TextField.create() {
                disabled = !(tableType == TableType.BRANCH || tableType == TableType.BUS)
                type = InputType.search
                size = Size.small
                value = filter
                autoFocus = true

                onChange = { event ->
                    setFilter(event.target.asDynamic().value as String)
                }

                label = ReactNode("Filter")
            }

        Box {
            css {
                display = Display.flex
                flexDirection = FlexDirection.column
                height = 100.pct // or a fixed height container
            }

            if(false) {
                Box {
                    css {
                        //                    Position.relative
                        flex = Flex(number(0.0), number(0.0), Auto.auto) // takes remaining space
                        //                    overflow = Auto.auto // scroll if content too big
                    }

                    Select {
                        value = tableType.name
                        margin = InputBaseMargin.dense

                        //            label = ReactNode("Type")
                        onChange = { event, _ ->
                            setTableType(TableType.valueOf(event.target.asDynamic().value))
                        }
                        for (tableType in TableType.values()) {
                            MenuItem {
                                dense = true
                                value = tableType.name
                                +tableType.toString()
                            }
                        }
                    }

                    //            FormControl {
                    //                FormControlLabel {
                    //                    control = Switch.create() {
                    //                        checked = aggregate
                    //
                    //                        onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                    //                            setAggregate(!aggregate)
                    //                        }
                    //                    }
                    //
                    //                    label = ReactNode("Aggregate cross-border")
                    //                }
                    //            }

                    FormControl {
                        FormControlLabel {
                            control = Switch.create() {
                                checked = crossBorder
                                disabled = tableType != TableType.BRANCH

                                onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                                    setCrossBorder(!crossBorder)
                                }
                            }

                            label = ReactNode("Filter non-cross-border")
                        }
                    }

                    TextField {
                        disabled = !(tableType == TableType.BRANCH || tableType == TableType.BUS)
                        type = InputType.search
                        size = Size.small
                        value = zoneFilter

                        onChange = { event ->
                            setZoneFilter(event.target.asDynamic().value as String)
                        }

                        label = ReactNode("Filter zones")
                    }

                    +filter
                }
            }

            if (tableType == TableType.CROSSBORDER && getPhysicalNetwork?.crossborder != null) {
                Box {
                    css {
                        flex = Flex(number(1.0), number(1.0), Auto.auto) // takes remaining space
                        overflow = Auto.auto // scroll if content too big
                    }

                    Typography {
                        +"Net state estimated cross border power flows"
                    }
                    CrossborderTable {
                        this.crossborderNetwork = getPhysicalNetwork.crossborder
                        this.lookup = { it.netTradeBalance }
                        this.transparent = props.transparent
                    }
                    Typography {
                        +"Export"
                    }
                    CrossborderTable {
                        this.crossborderNetwork = getPhysicalNetwork.crossborder
                        this.lookup = { it.export }
                        this.transparent = props.transparent
                    }
                    Typography {
                        +"Import"
                    }
                    CrossborderTable {
                        this.crossborderNetwork = getPhysicalNetwork.crossborder
                        this.lookup = { it.import }
                        this.transparent = props.transparent
                    }
                }

            } else if (tableType == TableType.BRANCH) {
                BranchTable {
                    this.dataLoader = props.dataLoader
                    this.rows = links
                    this.columns = DerivedBranchColumn.table
                    this.probing = props.dataLoader.logicalBranchProbing
                    this.selection = props.dataLoader.logicalBranchSelection
                    this.logicalBusProbing = props.dataLoader.logicalBusProbing
                    this.logicalBusSelection = props.dataLoader.logicalBusSelection
                    this.transparent = props.transparent
                    this.filter = filter
                }
            } else {
                BusTable {
                    this.dataLoader = props.dataLoader
                    this.rows = nodes
                    this.columns = DerivedBusColumn.table
                    this.probing = props.dataLoader.logicalBusProbing
                    this.selection = props.dataLoader.logicalBusSelection
                    this.transparent = props.transparent
                    this.filter = filter
                }
            }
        }
    } else if (tableType == TableType.BRANCH) {
        val branchDataFrame: AccessorRowMajorDataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?> =
            AccessorRowMajorDataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?>(
                DerivedBranchColumn.table.filterIsInstance<RowMajorDataFrame.Column<Branch, Any?>>()
                    .toTypedArray()
            )

        for (branch in getLogicalNetwork.links) {
            if (!crossBorder || branch.branch.crossBorder) {
                branchDataFrame.addRow(branch.branch)
            }
        }

        val tableComponent = DataFrameTable<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?>()
        tableComponent {
            this.dataFrame = branchDataFrame
            this.selection = selection
            this.transparent = props.transparent
        }
    } else {
        val busDataFrame: AccessorRowMajorDataFrame<Bus, RowMajorDataFrame.Column<Bus, Any?>, Any?> =
            AccessorRowMajorDataFrame<Bus, RowMajorDataFrame.Column<Bus, Any?>, Any?>(
                DerivedBusColumn.table.filterIsInstance<RowMajorDataFrame.Column<Bus, Any?>>()
                    .toTypedArray()
            )

        for (bus in getLogicalNetwork.nodes) {
            for (b in bus.buses) {
                busDataFrame.addRow(b)
            }
        }

        val tableComponent = DataFrameTable<Bus, RowMajorDataFrame.Column<Bus, Any?>, Any?>()
        tableComponent {
            this.dataFrame = busDataFrame
            this.selection = selection
            this.transparent = props.transparent
        }
    }
}
